/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Track_Status_Table_LabelInputs */



/**
* | output |
* | --- |
* | "Track Status Table" |
*
* @param {Work_Order_Publish_Track_Status_Table_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_track_status_table_label = /** @type {((inputs?: Work_Order_Publish_Track_Status_Table_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Track_Status_Table_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tableau de statut des pistes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Track-Statustabelle")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tabella dello stato della traccia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Таблица статуса отслеживания")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tabla de estado de la pista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("跟踪状态表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トラックステータステーブル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रैक स्थिति तालिका")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tabela de status da faixa")
	return /** @type {LocalizedString} */ ("Track Status Table")
});